import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const getBikeBrands = async (params) => {
    const id = params._id;

    if (id) {
        try {
            const res = await leadsServiceApi({
                method: 'get',
                url: `${PURCHASING_API.BIKE_BRANDS}/${id}`,
            });
            return {
                result: true,
                options: [res.data],
            };
        } catch (e) {
            return {
                msg: e.message,
                error: e,
            };
        }
    }

    const filterByName = params?.searchText || '';
    const limit = params?.limit || 25;

    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_BRANDS}?filterByName=${filterByName}&limit=${limit}`,
        });
        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/get_bike_brands_request.js